import script from "./CoherenceCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./CoherenceCheck.vue?vue&type=script&setup=true&lang=js"

import "./CoherenceCheck.vue?vue&type=style&index=0&id=52372b37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52372b37"]])

export default __exports__